import _objectSpread from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useMemo, useCallback, useEffect } from 'react';
import { ExpressCheckoutElement, PaymentMethodMessagingElement } from '@stripe/react-stripe-js';
import authStatusConstants from '../../../constants/authStatusConstants.js';
import currency from '../../../constants/currencyConstants.js';
import paymentMethodTypes from '../../../constants/paymentMethodTypeConstants.js';
import paymentStatus from '../../../constants/paymentStatusConstants.js';
import mapShippingRatesToStripe from '../../../utils/mapShippingRatesToStripe.js';
import { checkIsKlarnaCheckout, checkIsExpressEligibleCheckout, checkIsExpressCheckout, checkIsGooglePayCheckout, checkIsApplePayExpressCheckout, checkIsApplePayStandardCheckout, checkIsApplePayCheckout } from '../../../utils/paymentMethod.js';
import StubbedAddressActions$1 from '../../stubbed/stubbed-address-selector/StubbedAddressActions.js';
import StubbedAuthSelector from '../../stubbed/stubbed-auth-selector/StubbedAuthSelector.js';
import StubbedDismissActions from '../../stubbed/stubbed-dismiss-selector/StubbedDismissActions.js';
import StubbedOrderTotals from '../../stubbed/stubbed-order-totals/StubbedOrderTotals.js';
import StubbedAddressActions from '../../stubbed/stubbed-shipping-address-selector/StubbedShippingActions.js';
import StubbedStatusSelector from '../../stubbed/stubbed-status-selector/StubbedStatusSelector.js';
import StubbedWarningMessage from '../../stubbed/stubbed-warning-message/StubbedWarningMessage.js';
import StubbedWrapper from '../../stubbed/stubbed-wrapper/StubbedWrapper.js';
import { isProcessingStyle, isLoadingIndicatorStyle } from './StripeExpressCheckoutElement.styles.js';
var StripeExpressCheckoutElement = function StripeExpressCheckoutElement(_ref) {
  var amount = _ref.amount,
    billing_details = _ref.billingDetails,
    classNames = _ref.classNames,
    elements = _ref.elements,
    isProcessing = _ref.isProcessing,
    isStubbed = _ref.isStubbed,
    loadingIndicator = _ref.loadingIndicator,
    _ref$onReadyToRenderH = _ref.onReadyToRenderHandler,
    onReadyToRenderHandler = _ref$onReadyToRenderH === void 0 ? function () {} : _ref$onReadyToRenderH,
    _ref$onSubmitHandler = _ref.onSubmitHandler,
    onSubmitHandler = _ref$onSubmitHandler === void 0 ? function () {} : _ref$onSubmitHandler,
    paymentHandlers = _ref.paymentHandlers,
    paymentMethodType = _ref.paymentMethodType;
  var _useState = useState(paymentStatus.AUTHORISED),
    _useState2 = _slicedToArray(_useState, 2),
    stubbedStatus = _useState2[0],
    setStubbedStatus = _useState2[1];
  var _useState3 = useState(authStatusConstants.COMPLETE),
    _useState4 = _slicedToArray(_useState3, 2),
    stubbedAuthStatus = _useState4[0],
    setStubbedAuthStatus = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    shippingOptionRates = _useState6[0],
    setShippingOptionRates = _useState6[1];
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    shippingAmount = _useState8[0],
    setShippingAmount = _useState8[1];
  var _useState9 = useState(undefined),
    _useState0 = _slicedToArray(_useState9, 2),
    selectedShippingOptionIdentifier = _useState0[0],
    setSelectedShippingOptionIdentifier = _useState0[1];
  var _useState1 = useState(),
    _useState10 = _slicedToArray(_useState1, 2),
    stubbedWarning = _useState10[0],
    setStubbedWarning = _useState10[1];
  var _useMemo = useMemo(function () {
      return {
        isApplePayCheckout: checkIsApplePayCheckout(paymentMethodType),
        isApplePayStandardCheckout: checkIsApplePayStandardCheckout(paymentMethodType),
        isApplePayExpressCheckout: checkIsApplePayExpressCheckout(paymentMethodType),
        isGooglePayCheckout: checkIsGooglePayCheckout(paymentMethodType),
        isExpressCheckout: checkIsExpressCheckout(paymentMethodType),
        isExpressEligibleCheckout: checkIsExpressEligibleCheckout(paymentMethodType),
        isKlarnaCheckout: checkIsKlarnaCheckout(paymentMethodType)
      };
    }, [paymentMethodType]),
    isApplePayCheckout = _useMemo.isApplePayCheckout,
    isApplePayStandardCheckout = _useMemo.isApplePayStandardCheckout,
    isApplePayExpressCheckout = _useMemo.isApplePayExpressCheckout,
    isGooglePayCheckout = _useMemo.isGooglePayCheckout,
    isExpressCheckout = _useMemo.isExpressCheckout,
    isExpressEligibleCheckout = _useMemo.isExpressEligibleCheckout,
    isKlarnaCheckout = _useMemo.isKlarnaCheckout;
  var onDismissHandler = useCallback(function () {
    if (!(paymentHandlers !== null && paymentHandlers !== void 0 && paymentHandlers.onDismiss)) {
      console.warn('No onDismiss handler provided.');
    } else {
      paymentHandlers.onDismiss();
    }
  }, [paymentHandlers]);
  var logAndSetWarning = useCallback(function (warning) {
    if (warning !== null && warning !== void 0 && warning.title) {
      console.warn(warning.title);
    }
    setStubbedWarning(warning);
  }, []);
  var onClickHandler = useCallback(/*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(event) {
      var resolve;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            resolve = event.resolve;
            if (!(paymentHandlers !== null && paymentHandlers !== void 0 && paymentHandlers.onExpressCheckoutClick)) {
              console.warn('No onExpressCheckoutClick handler provided.');
            } else {
              paymentHandlers.onExpressCheckoutClick();
            }
            resolve();
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [paymentHandlers]);
  var onConfirmHandler = useCallback(/*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event) {
      var billingDetails, shippingAddress, paymentFailed, phone, mergedBillingDetails, mergedShippingAddress, billingResult, shouldRejectBilling, shippingResult, message, shouldRejectShipping;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            billingDetails = event.billingDetails, shippingAddress = event.shippingAddress, paymentFailed = event.paymentFailed;
            logAndSetWarning({});
            if (billingDetails) {
              _context2.next = 6;
              break;
            }
            logAndSetWarning({
              title: 'Missing billing details from Stripe event'
            });
            paymentFailed === null || paymentFailed === void 0 || paymentFailed({
              reason: 'invalid_billing_address'
            });
            return _context2.abrupt("return");
          case 6:
            phone = (billingDetails === null || billingDetails === void 0 ? void 0 : billingDetails.phone) || (billing_details === null || billing_details === void 0 ? void 0 : billing_details.phone) || '';
            mergedBillingDetails = _objectSpread(_objectSpread({}, billingDetails), {}, {
              phone: phone
            });
            if (!isApplePayCheckout) {
              _context2.next = 41;
              break;
            }
            if (!(paymentHandlers !== null && paymentHandlers !== void 0 && paymentHandlers.validateBillingDetails)) {
              _context2.next = 15;
              break;
            }
            _context2.next = 12;
            return paymentHandlers.validateBillingDetails({
              billingDetails: mergedBillingDetails
            });
          case 12:
            _context2.t0 = _context2.sent;
            _context2.next = 16;
            break;
          case 15:
            _context2.t0 = {
              shouldReject: true
            };
          case 16:
            billingResult = _context2.t0;
            shouldRejectBilling = billingResult.shouldReject;
            if (!shouldRejectBilling) {
              _context2.next = 22;
              break;
            }
            logAndSetWarning({
              title: 'Invalid billing details from Stripe event'
            });
            paymentFailed === null || paymentFailed === void 0 || paymentFailed({
              reason: 'invalid_billing_address'
            });
            return _context2.abrupt("return");
          case 22:
            if (!isApplePayExpressCheckout) {
              _context2.next = 41;
              break;
            }
            if (shippingAddress) {
              _context2.next = 27;
              break;
            }
            logAndSetWarning({
              title: 'Missing shipping address from Stripe event'
            });
            paymentFailed === null || paymentFailed === void 0 || paymentFailed({
              reason: 'invalid_shipping_address'
            });
            return _context2.abrupt("return");
          case 27:
            mergedShippingAddress = _objectSpread(_objectSpread({}, shippingAddress), {}, {
              phone: phone
            });
            if (!(paymentHandlers !== null && paymentHandlers !== void 0 && paymentHandlers.validateShippingAddress)) {
              _context2.next = 34;
              break;
            }
            _context2.next = 31;
            return paymentHandlers.validateShippingAddress({
              shippingAddress: mergedShippingAddress
            });
          case 31:
            _context2.t1 = _context2.sent;
            _context2.next = 35;
            break;
          case 34:
            _context2.t1 = {
              message: undefined,
              shouldReject: true
            };
          case 35:
            shippingResult = _context2.t1;
            message = shippingResult.message, shouldRejectShipping = shippingResult.shouldReject;
            if (!shouldRejectShipping) {
              _context2.next = 41;
              break;
            }
            logAndSetWarning({
              body: message,
              title: 'Invalid shipping details from Stripe event'
            });
            paymentFailed === null || paymentFailed === void 0 || paymentFailed({
              message: message,
              reason: 'invalid_shipping_address'
            });
            return _context2.abrupt("return");
          case 41:
            onSubmitHandler({
              billingDetails: mergedBillingDetails,
              selectedShippingOptionIdentifier: selectedShippingOptionIdentifier,
              shippingAddress: mergedShippingAddress,
              stubbedAuthStatus: stubbedAuthStatus,
              stubbedStatus: stubbedStatus
            });
          case 42:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }(), [billing_details, isApplePayCheckout, isApplePayExpressCheckout, logAndSetWarning, onSubmitHandler, paymentHandlers, selectedShippingOptionIdentifier, stubbedAuthStatus, stubbedStatus]);
  var onReadyHandler = useCallback(function (event) {
    var _paymentHandlers$onRe, _paymentHandlers$onAv;
    var availablePaymentMethods = event.availablePaymentMethods;
    var normalisedMethod = paymentMethodType === paymentMethodTypes.APPLE_PAY_EXPRESS ? paymentMethodTypes.APPLE_PAY : paymentMethodType;
    var isAvailable = isExpressCheckout ? !!(availablePaymentMethods !== null && availablePaymentMethods !== void 0 && availablePaymentMethods[normalisedMethod]) : false;
    onReadyToRenderHandler(isAvailable);
    paymentHandlers === null || paymentHandlers === void 0 || (_paymentHandlers$onRe = paymentHandlers.onReady) === null || _paymentHandlers$onRe === void 0 || _paymentHandlers$onRe.call(paymentHandlers, isAvailable);
    paymentHandlers === null || paymentHandlers === void 0 || (_paymentHandlers$onAv = paymentHandlers.onAvailablePaymentMethods) === null || _paymentHandlers$onAv === void 0 || _paymentHandlers$onAv.call(paymentHandlers, availablePaymentMethods);
  }, [isExpressCheckout, onReadyToRenderHandler, paymentHandlers, paymentMethodType]);
  var onShippingAddressChangeHandler = useCallback(/*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(event) {
      var _stripeShippingRates$, _stripeShippingRates$2;
      var resolve, reject, shippingAddress, result, _result$shippingRates, shippingRates, shouldReject, stripeShippingRates;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            resolve = event.resolve, reject = event.reject, shippingAddress = event.address;
            logAndSetWarning({});
            if (!(paymentHandlers !== null && paymentHandlers !== void 0 && paymentHandlers.onShippingAddressChange)) {
              _context3.next = 8;
              break;
            }
            _context3.next = 5;
            return paymentHandlers.onShippingAddressChange({
              shippingAddress: shippingAddress
            });
          case 5:
            _context3.t0 = _context3.sent;
            _context3.next = 9;
            break;
          case 8:
            _context3.t0 = {
              shouldReject: true
            };
          case 9:
            result = _context3.t0;
            _result$shippingRates = result.shippingRates, shippingRates = _result$shippingRates === void 0 ? [] : _result$shippingRates, shouldReject = result.shouldReject;
            stripeShippingRates = mapShippingRatesToStripe(shippingRates);
            setShippingOptionRates(stripeShippingRates);
            setSelectedShippingOptionIdentifier(stripeShippingRates === null || stripeShippingRates === void 0 || (_stripeShippingRates$ = stripeShippingRates[0]) === null || _stripeShippingRates$ === void 0 ? void 0 : _stripeShippingRates$.id);
            setShippingAmount(stripeShippingRates === null || stripeShippingRates === void 0 || (_stripeShippingRates$2 = stripeShippingRates[0]) === null || _stripeShippingRates$2 === void 0 ? void 0 : _stripeShippingRates$2.amount);
            if (!shouldReject) {
              _context3.next = 19;
              break;
            }
            logAndSetWarning({
              title: "Recipient's shipping address is invalid"
            });
            reject();
            return _context3.abrupt("return");
          case 19:
            resolve({
              shippingRates: stripeShippingRates
            });
          case 20:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x3) {
      return _ref4.apply(this, arguments);
    };
  }(), [logAndSetWarning, paymentHandlers]);
  var onShippingRateChangeHandler = useCallback(/*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(event) {
      var resolve, shippingRate, shippingRateAmount, id;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            resolve = event.resolve, shippingRate = event.shippingRate;
            shippingRateAmount = shippingRate.amount, id = shippingRate.id;
            setSelectedShippingOptionIdentifier(id);
            setShippingAmount(shippingRateAmount);
            elements === null || elements === void 0 || elements.update({
              amount: amount + shippingRateAmount
            });
            resolve();
          case 6:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function (_x4) {
      return _ref5.apply(this, arguments);
    };
  }(), [amount, elements]);
  useEffect(function () {
    if (isStubbed) {
      var _paymentHandlers$onRe2, _paymentHandlers$onAv2;
      onReadyToRenderHandler(true);
      paymentHandlers === null || paymentHandlers === void 0 || (_paymentHandlers$onRe2 = paymentHandlers.onReady) === null || _paymentHandlers$onRe2 === void 0 || _paymentHandlers$onRe2.call(paymentHandlers, true);
      paymentHandlers === null || paymentHandlers === void 0 || (_paymentHandlers$onAv2 = paymentHandlers.onAvailablePaymentMethods) === null || _paymentHandlers$onAv2 === void 0 || _paymentHandlers$onAv2.call(paymentHandlers, {
        amazonPay: false,
        applePay: true,
        googlePay: true,
        klarna: true,
        link: false,
        paypal: false
      });
    }
  }, [isStubbed]);
  var expressCheckoutElementOptions = useMemo(function () {
    if (!isApplePayExpressCheckout) return {};
    return {
      allowedShippingCountries: ['GB', 'GG', 'IM', 'JE'],
      shippingAddressRequired: true,
      shippingRates: []
    };
  }, [isApplePayExpressCheckout]);
  var renderStubbedContent = useCallback(function () {
    return jsxs(StubbedWrapper, {
      children: [jsx(StubbedWarningMessage, {
        message: stubbedWarning
      }), jsx(StubbedStatusSelector, {
        stubbedStatus: stubbedStatus,
        onChange: setStubbedStatus
      }), isApplePayExpressCheckout && jsx(StubbedAddressActions, {
        onShippingAddressChange: onShippingAddressChangeHandler,
        selectedShippingOptionIdentifier: selectedShippingOptionIdentifier,
        setSelectedShippingOptionIdentifier: setSelectedShippingOptionIdentifier,
        setShippingAmount: setShippingAmount,
        shippingRates: shippingOptionRates
      }), (isKlarnaCheckout || isGooglePayCheckout) && jsx(StubbedAuthSelector, {
        stubbedAuthStatus: stubbedAuthStatus,
        stubbedStatus: stubbedStatus,
        onChange: setStubbedAuthStatus
      }), (isKlarnaCheckout || isGooglePayCheckout || isApplePayStandardCheckout || isApplePayExpressCheckout && selectedShippingOptionIdentifier) && jsx(StubbedAddressActions$1, {
        onConfirm: onConfirmHandler,
        paymentMethodType: paymentMethodType
      }), jsx(StubbedDismissActions, {
        onCancel: onDismissHandler,
        onEscape: onDismissHandler
      }), jsx(StubbedOrderTotals, {
        amount: amount,
        paymentMethodType: paymentMethodType,
        shippingAmount: shippingAmount
      })]
    });
  }, [amount, isApplePayExpressCheckout, isApplePayStandardCheckout, isGooglePayCheckout, isKlarnaCheckout, onConfirmHandler, onDismissHandler, onShippingAddressChangeHandler, paymentMethodType, selectedShippingOptionIdentifier, shippingOptionRates, stubbedAuthStatus, stubbedStatus, stubbedWarning]);
  var renderLiveContent = useCallback(function () {
    return jsxs("div", {
      style: isProcessingStyle,
      children: [isProcessing && jsx("div", {
        style: isLoadingIndicatorStyle,
        children: loadingIndicator
      }), jsx(ExpressCheckoutElement, {
        onCancel: onDismissHandler,
        onConfirm: onConfirmHandler,
        onClick: onClickHandler,
        onEscape: onDismissHandler,
        onReady: onReadyHandler,
        onShippingAddressChange: onShippingAddressChangeHandler,
        onShippingRateChange: onShippingRateChangeHandler,
        options: _objectSpread({
          billingAddressRequired: true,
          buttonHeight: 40,
          emailRequired: true,
          paymentMethods: {
            amazonPay: 'never',
            applePay: isExpressEligibleCheckout || isApplePayCheckout ? 'auto' : 'never',
            googlePay: isExpressEligibleCheckout || isGooglePayCheckout ? 'auto' : 'never',
            klarna: isExpressEligibleCheckout || isKlarnaCheckout ? 'auto' : 'never',
            link: 'never',
            paypal: 'never'
          },
          phoneNumberRequired: true
        }, expressCheckoutElementOptions)
      }), paymentMethodType === paymentMethodTypes.KLARNA && jsx(PaymentMethodMessagingElement, {
        options: {
          amount: amount,
          currency: currency.UPPER
        }
      })]
    });
  }, [expressCheckoutElementOptions, isApplePayCheckout, isExpressEligibleCheckout, isGooglePayCheckout, isKlarnaCheckout, isProcessing, onConfirmHandler, onDismissHandler, onReadyHandler, onShippingAddressChangeHandler, onShippingRateChangeHandler]);
  return jsx("div", {
    className: classNames === null || classNames === void 0 ? void 0 : classNames.expressPaymentElement,
    children: isStubbed ? renderStubbedContent() : renderLiveContent()
  });
};
export { StripeExpressCheckoutElement as default };